import axios from 'axios';
import { PORTFOLIO_MANAGER_MODELS_UPDATED, PORTFOLIO_MANAGER_SELECTED_MODEL_UPDATED, PORTFOLIO_MANAGER_UPDATE } from './types/actions';
import { SelectOption } from '../common/types';
import { StandardThunkAction } from '../store/store';
import { PortfolioManagerConfigurationType } from './types/portfolioManager';
import { PortfolioDesignerConfiguration } from './types/portfolioDesigner';
import { getPathsClientId } from '../common/utils';
import { DispatchFunction } from '../reducers';

export const getModels = async(): Promise<PortfolioDesignerConfiguration[]> => {
    const { data } = await axios.get(`/api/designer/models`)
    const { models } = data

    return models;
}

export const getExternalModels = async(): Promise<PortfolioDesignerConfiguration[]> => {
    const profileId = getPathsClientId()

    const { data } = await axios.get(`/api/clients/${profileId}/designer/models/external`)
    const { models } = data

    return models;
}

export const updateModelsForType = (type: PortfolioManagerConfigurationType, models: SelectOption[]): StandardThunkAction => {
    return async(dispatch: any): Promise<void> => {
        dispatch({ type: PORTFOLIO_MANAGER_MODELS_UPDATED, payload: { type, models } })
    }
}

export const updateSelectedModelForType = (type: PortfolioManagerConfigurationType, selectedOption: SelectOption): StandardThunkAction => {
    return async(dispatch: any): Promise<void> => {
        dispatch({ type: PORTFOLIO_MANAGER_SELECTED_MODEL_UPDATED, payload: { type, selectedOption } })
    }
}

export const updateParameter = (payload: any) => {
    return { type: PORTFOLIO_MANAGER_UPDATE, payload}
}

export const loadAccountOptions = () => {
    return async(dispatch: DispatchFunction): Promise<void> => {
        const externalModels = await getExternalModels();

        const accountModelsOptions: SelectOption[] = externalModels?.length > 0 ? externalModels.map((item) => {
            return {
                label: item.name,
                value: item.id,
                item 
            }
        }) : [];

        dispatch(updateModelsForType('account', accountModelsOptions))
    }
}